import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserRolesService } from '../services/user-roles.service';
import { rolesHavePortalAccess } from '../utils/auth-claims.utils';
import { loginUrlTree } from '../utils/login-return-url.utils';

/**
 * Grants access to any user whose token carries a role other than `EndUser`. What each role
 * actually gets to see is decided per menu item and page, not here. Anyone else goes to login.
 */
export const roleGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userRolesService = inject(UserRolesService);

  // Read the current auth state rather than the cached snapshot: right after logout the
  // snapshot still holds the signed-out user's roles, which would wave them back through.
  return userRolesService.resolveCurrentRoles().pipe(
    map((roles) => rolesHavePortalAccess(roles) || loginUrlTree(router, state, roles))
  );
};
